import accounting from 'accounting'

export const format = (date: string): string => {
  const myDate = new Date(date)
  const year = myDate.getFullYear()
  const month = myDate.getMonth() + 1
  const day = myDate.getDate()
  return `${year}-${month}-${day}`
}

// 千分号
export const formatNumber = (value: number): string => {
  return accounting.formatNumber(value)
}

// 千分号保留小数
export const formatNumberWithFraction = (value: number, fraction: number): string => {
  return accounting.formatNumber(value, fraction, ',')
}

export const getUrlParams = (url: string) => {
  try {
      const URL = url.split('?')[1];
      let obj = {}; // 声明参数对象
      let arr = URL.split("&");
      for (let item of arr) {
        let arrNew = item.split("="); 
        obj[arrNew[0]] = arrNew[1];
      }
      return obj;
  } catch (e) {
      return null;
  }
}

export const CustomLocalStorage = {
  prefix: '',
  setItem: (key: string, value: any, ttl = 24 * 60 * 60 * 1000) => { // 默认24小时
    const prefix = '';
    const now = Date.now();
    const item = {
      value,
      expiry: now + ttl,
      timestamp: now,
    };
    localStorage.setItem(prefix + key, JSON.stringify(item));
  },
  getItem: (key: string) => {
    const prefix = '';
    const fullKey = prefix + key;
    const itemStr = localStorage.getItem(fullKey);
    
    if (!itemStr) {
      return null;
    }
    
    try {
      const item = JSON.parse(itemStr);
      const now = Date.now();
      
      // 检查是否过期
      if (!item.expiry || now > item.expiry) {
        localStorage.removeItem(prefix + key);
        return null;
      }
      
      return item.value;
    } catch (error) {
      console.error('解析存储数据失败:', error);
      localStorage.removeItem(prefix + key);
      return null;
    }
  },
  removeItem: (key: string) => {
    const prefix = '';
    localStorage.removeItem(prefix + key);
  },
  clear: () => {
    const prefix = '';
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.startsWith(prefix)) {
        localStorage.removeItem(key);
      }
    });
  },
  cleanup: () => {
    const prefix = '';
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.startsWith(prefix)) {
        // 通过getItem自动触发过期检查
        CustomLocalStorage.getItem(key.substring(prefix.length));
      }
    });
  }
}




// WEBPACK FOOTER //
// ./src/utils/index.tsx